export const css = {
	root: 'HtlCq2Fo',
	instructions: '_2rft3Xv-',
	inputWrapper: '_1qasw6y4',
	listButton: 'akTLVlPr',
	listActive: '_30ZZ_4fo',
	listInactive: '_2YhZAMsA',
	searchResults: '_1s9YGtSv',
	resultHead: '_3L7VXxRS',
	resultSet: '_9bfyClkJ',
	topicList: 'sE2JXjhe',
	' _key': 'search-widget/search'
};

export default css;
